import { useEffect, useMemo, useState } from "react";
import { IBudgetVersionService, IBudgetVersionServiceItem } from "../../../../../models/budgetV2";
import { ITruckerPayPlanData } from "../../../../../models/truckerPayPlan";

export const useBudgetServiceForm = (service: IBudgetVersionService, setService: (service: IBudgetVersionService) => void, truckerPayPlan?: ITruckerPayPlanData | null, initialService?: IBudgetVersionService) => {
    const [loadingServiceItems, setLoadingServiceItems] = useState(false);
    const [serviceItems, setServiceItems] = useState<IBudgetVersionServiceItem[]>([]);
  
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const initialServiceItems = (initialService?.items?.length ? initialService.items : initialService?.serviceItems) ?? [];
  
    const calculateItemSubtotal = (item: IBudgetVersionServiceItem, onlyCovered: boolean = false) => {
      if (item.removed) return 0;
      if (onlyCovered && item.isCovered !== true) return 0;

      const itemValue = item.value || 0;
      let clean = String(item.quantity ?? '0').replace(/[^\d.,]/g, '');
      clean = clean.replace(',', '.');
      const quantityParsed = Number.parseFloat(clean);
      const quantity = Number.isNaN(quantityParsed) ? 0 : quantityParsed;
      return itemValue * quantity * (1 - (item.discount ?? 0) / 100);
    }
  
    const calculatedSubtotal = useMemo(() => {
      if (serviceItems.length === 0) return 0;
      const total = serviceItems.reduce((sum, item) => sum + calculateItemSubtotal(item, false), 0);
      return total;
    }, [serviceItems]);
  
    const calculatedTruckerPayPlanSubtotal = useMemo(() => {
      if (serviceItems.length === 0) return 0;
      const total = serviceItems.reduce((sum, item) => sum + calculateItemSubtotal(item, true), 0);
      return total;
    }, [serviceItems]);
  
    const handleRemoveService = () => setShowConfirmDialog(true);
  
    const showDiscountColumn = !truckerPayPlan || (truckerPayPlan.availableCoverageBalance ?? 0) === 0;
  
    useEffect(() => {
      const items = service.items?.length ? service.items : service.serviceItems;
      setServiceItems(items ?? []);
    }, [service.id, service.items, service.serviceItems]);

    const applyServiceItemsChange = (nextItems: IBudgetVersionServiceItem[]) => {
      setServiceItems(nextItems);
      setService({ ...service, items: nextItems, serviceItems: nextItems });
    };

    return {
        loadingServiceItems,
        serviceItems,
        initialServiceItems,
        showConfirmDialog,
        calculatedSubtotal,
        calculatedTruckerPayPlanSubtotal,
        showDiscountColumn,
        
        setLoadingServiceItems,
        applyServiceItemsChange,
        setServiceItems,
        setShowConfirmDialog,
        handleRemoveService,
    };
};